import { Suspense, lazy } from "react";
import { LoadingState } from "../components/states";
import { HorizonLayout } from "./layouts";
import type { DashboardData } from "./types";

/** Horizon is the home every app opens on; Aurora is the same page at /home2 (preview, restored 2026-10-13). */
export type HomeDesign = "horizon" | "aurora";

// Aurora is loaded only when /home2 is opened: its stylesheet and its font (Sora) come with it, never with Horizon.
const AuroraDashboard = lazy(async () => ({
  default: (await import("../aurora")).AuroraDashboard,
}));

export interface HomeDashboardProps {
  readonly data: DashboardData;
  readonly design?: HomeDesign;
}

/** An app's home page in the Horizon design, or in Aurora. The Horizon frame (floating sidebar, tinted page) is global.css's. */
export function HomeDashboard({ data, design = "horizon" }: HomeDashboardProps) {
  if (design === "aurora") {
    return (
      <Suspense fallback={<LoadingState rows={4} label="Loading Aurora" />}>
        <AuroraDashboard data={data} />
      </Suspense>
    );
  }
  return (
    <div className="pv-root">
      <HorizonLayout data={data} />
    </div>
  );
}
